import React from 'react';
import CardItem from './CardItem';
import './Cards.css';
import Testimonials from './Testimonials.js';

function Cards() {
  return (
    <div className='cards'>
        <p className='card__header'>My Achievements</p>

        <div className='cards__video'>
        <iframe className='propnex__video' src="https://www.youtube.com/embed/HSUlzxHS4Z8?si=vVYBLk07NRPspOiA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        <div className='cards__video'>
        <iframe className='propnex__video' src="videos/PAA2026 Yvonne See Wai Chie-943 Position.mp4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        <div className="cards__container">

        <ul className="cards__items">
            <CardItem src="images/awards/jul-2026.jpeg"
            text="Super Gold Achiever"
            label='July 2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/edgeprop_roundtable_2026.jpeg"
            text="Qualified Member of Edgeprop Roundtable 2026"
            label='2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/labc-2Q2026.jpeg"
            text="LABC 2Q2026 Top Producer"
            label='2Q2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/jun-2026.jpeg"
            text="Gold Achiever"
            label='June 2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/may-2026.jpeg"
            text="Super Gold Achiever"
            label='May 2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/APR-2026.jpeg"
            text="Super Gold Achiever"
            label='April 2026'
            path='/services'
            />
        </ul>
        <ul className="cards__items">
            <CardItem src="images/awards/1Q2026.jpeg"
            text="Top 10% - 943rd Among 12000 Propnex Agents"
            label='1Q2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/DLD-12th Postion.jpeg"
            text="12th Position Within Desmond Liew District"
            label='1Q2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/MLD-170th Position.jpeg"
            text="170th Position Within Matt Lam Advisory"
            label='1Q2026'
            path='/services'
            />
        </ul>
        <ul className="cards__items">
            <CardItem src="images/awards/MAR-2026.jpeg"
            text="Super Gold Achiever"
            label='March 2026'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Sep-2025.jpg"
            text="Gold Achiever"
            label='September 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Jul-2025.jpg"
            text="Super Gold Achiever"
            label='July 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Jun-2025.jpg"
            text="Gold Achiever"
            label='June 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/May_2025.jpg"
            text="Gold Achiever"
            label='May 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Assoc_Grp_Director_Promotion.jpg"
            text="Associate Group Director"
            label='April 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Apr_2025.jpg"
            text="Gold Achiever"
            label='April 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
          <CardItem src="images/awards/1st_Quarter_2025.jpg"
          text="Top 10% Producer"
          label='1Q 2025'
          path='/services'
          />
        </ul>

        <ul className="cards__items">
            <CardItem src="images/awards/Mar_2025.jpg"
            text="Gold Achiever"
            label='March 2025'
            path='/services'
            />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/Feb-2025.jpg"
                    text="Gold Achiever"
                    label='February 2025'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/Jan-2025.jpg"
                    text="Platinum Achiever"
                    label='January 2025'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/desmond_team_2024.jpg"
                    text="11th Position Desmond Liew District"
                    label='Top Producer 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/matt_lam_team_2024.jpg"
                    text="153rd Position Matt Lam Advisory"
                    label='Top Producer 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/Top-producer-24.jpg"
                    text="Top 960th Producer 2024"
                    label='Top Producer 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/sep-2024-2.jpg"
                    text="Top Transactor"
                    label='September 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/sep-2024-1.jpg"
                    text="Super Gold Achiever"
                    label='September 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jul-2024.jpg"
                    text="Gold Achiever"
                    label='July 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jun-2024.jpg"
                    text="Gold Achiever"
                    label='June 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/apr-2024.jpg"
                    text="Gold Achiever"
                    label='April 2024'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/y2023-1.jpg"
                    text="Top 10% of Producers in 2023"
                    label='Year 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/y2023.jpg"
                    text="Top 74th Producer for the Year 2023"
                    label='Year 2023'
                    path='/services'
                    />
        </ul>
        <ul className="cards__items">
                    <CardItem src="images/awards/2Q-2023.jpg"
                    text="Top 140th Producer Among 12000 Propnex Agents"
                    label='2Q 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/oct-2023.jpg"
                    text="Gold Achiever"
                    label='October 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/sep-2023.jpg"
                    text="Gold Achiever"
                    label='September 2023'
                    path='/services'
                    />
        </ul> 

        <ul className="cards__items">
                    <CardItem src="images/awards/jul-2023.jpg"
                    text="Super Gold Achiever"
                    label='July 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jun-2023-3.jpg"
                    text={<div>Top 30 Producers<br/>(26th Place)</div>}
                    label='June 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jun-2023-2.jpg"
                    text={<div>Platinum Achiever<br/>(Award Winning Ceremony)</div>}
                    label='June 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jun-2023-1.jpg"
                    text="Platinum Achiever"
                    label='June 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/apr-2023.jpg"
                    text="Gold Achiever"
                    label='April 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jan-2023-3.jpg"
                    text={<div>Top 50 Producers<br/>(2nd Place)</div>}
                    label='January 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jan-2023-2.jpg"
                    text={<div>Platinum Producer<br/>(Award Winning Ceremony)</div>}
                    label='January 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jan-2023-1.jpg"
                    text="Platinum Producer"
                    label='January 2023'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/sep-2022-2.jpg"
                    text={<div>Top 100 Producers<br/>(95th Place)</div>}
                    label='September 2022'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/sep-2022-1.jpg"
                    text="Elite Gold Producer"
                    label='September 2022'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/may-2022.jpg"
                    text="Gold Champion"
                    label='May 2022'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/jan-2022.jpg"
                    text="Gold Champion"
                    label='January 2022'
                    path='/services'
                    />
        </ul>

        <ul className="cards__items">
                    <CardItem src="images/awards/nov-2021.jpg"
                    text="Gold Champion"
                    label='November 2021'
                    path='/services'
                    />
        </ul>
        </div>
        <Testimonials/>
    </div>
  )
}

export default Cards